import {
  Box,
  CircularProgress,
  List,
  ListItemButton,
  ListItemText,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useKbArticles } from '../api/hooks';

export function KbListPage() {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const { data, isLoading } = useKbArticles(search.trim() || undefined);

  return (
    <Box>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
        <Typography variant="h1">Knowledge base</Typography>
      </Stack>

      <TextField
        size="small"
        label="Search articles"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
      />

      {isLoading ? (
        <Box sx={{ display: 'grid', placeItems: 'center', py: 6 }}>
          <CircularProgress />
        </Box>
      ) : data && data.length > 0 ? (
        <List sx={{ bgcolor: 'background.paper', borderRadius: 1 }}>
          {data.map((article) => (
            <ListItemButton
              key={article.slug}
              divider
              onClick={() => navigate(`/kb/${article.slug}`)}
            >
              <ListItemText
                primary={article.title}
                secondary={
                  <>
                    {article.category ? `${article.category} · ` : ''}
                    Updated {new Date(article.updatedAt).toLocaleDateString()}
                  </>
                }
              />
            </ListItemButton>
          ))}
        </List>
      ) : (
        <Typography color="text.secondary">
          {search.trim()
            ? 'No articles match your search.'
            : 'No articles have been published yet.'}
        </Typography>
      )}
    </Box>
  );
}
